import React from "react";
import { Box, Button, Link } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useDispatchWrapper } from "../../../../../../hooks";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../../../../constants/enums";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import { IHabitationalBinderCsio } from "../../../../../../redux/habitationalPolicy/habitationalBinderCsio/habitationalBinderCsio.types";
import { fetchHabitationalCsioBinderListAsync } from "../../../../../../redux/habitationalPolicy/habitationalBinderCsio/habitationalBinderCsioActions";
import { CustomChip } from "../../../../../../components/CustomChip";
import { NotificationsActive, ThumbUpAlt } from "@mui/icons-material";

export const HabitationalBinderCsioList = () => {
  const data1 = useOutletContext() as any;
  const customerId = data1[0];
  const customerpolicyId = data1[1];
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.habitational.binderCsio
  );
  const dispatch = useDispatchWrapper();

  const habitationalBinderCsioProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/habitational-policy/${customerId}/binder-csio-tab/${customerpolicyId}/binder`
                  );
                }}
              >
                Add Binder Csio
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: IHabitationalBinderCsio) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/habitational-policy/${customerId}/binder-csio-tab/${customerpolicyId}/binder/${row.incremental_number}`
                )
              }
            >
              {row.incremental_number}
            </Link>
          );
        },
      },

      {
        key: "insurance_company",
        headerName: "Insurance Company",
        fieldName: "insurance_company",
        renderType: RenderType.TEXT,
        exportCellWidth: 15,
      },

      {
        key: "applicant_address",
        headerName: "Address",
        fieldName: "applicant_address",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        onRowCellValueRender: (value, row: IHabitationalBinderCsio) => {
          return row.applicant_address + " " + row.applicant_postal_code;
        },
      },

      {
        key: "brokerage_full_name",
        headerName: "Broker Name",
        fieldName: "brokerage_full_name",
        renderType: RenderType.CHIP_WARNING,
        exportCellWidth: 20,
      },
      {
        key: "brokerage_contract_number",
        headerName: "Contract Number",
        fieldName: "brokerage_contract_number",
        renderType: RenderType.DATE,
        exportCellWidth: 20,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.TEXT,
        exportCellWidth: 15,
        onRowCellRender: (value, row) => {
          if (row.status === "ACTIVE") {
            return (
              <CustomChip
                color="success"
                icon={<NotificationsActive />}
                content={"Active"}
                size="small"
              />
            );
          } else {
            return (
              <CustomChip
                color="success"
                icon={<ThumbUpAlt />}
                content={"InActive"}
                size="small"
              />
            );
          }
        },
      },
      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IHabitationalBinderCsio) => {
          return (
            <StandardTableActions
              //onViewClick={() => setOpenView(row)}
              onEditClick={() => {
                navigate(
                  `/habitational-policy/${customerId}/binder-csio-tab/${customerpolicyId}/binder/${row.incremental_number}`
                );
              }}
              //  more={{ menuItems: menuItems }}
            />
          );
        },
      },
    ],
    items: data,
  };

  React.useEffect(() => {
    dispatch(fetchHabitationalCsioBinderListAsync(customerpolicyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerpolicyId]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...habitationalBinderCsioProps} />
      </Box>
    </>
  );
};
